import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function getAllProjects(callback) {
	firebaseRef.ref('/kavtek_companies/').on('value', (snapshot) => {
		var companyParent = snapshot.val();

		var companyParentKeys = Object.keys(companyParent);

		var companyArr = [];

		companyParentKeys.forEach((key) => {
			var company = companyParent[key];
			company['id'] = key;

			companyArr.push(company);
		});

		console.log('companyArr', companyArr);
		callback(companyArr);
	});
}
